@if (!isLoading && selectedConsumer && selectedLocation && isEmpty) {
  <emm-no-submenus
    [selectedConsumerName]="selectedConsumer.name"
  ></emm-no-submenus>
}
@if (selectedLocation && !isEmpty) {
  <tree-root
    class="node-tree"
    [nodes]="items"
    [options]="options"
    (moveNode)="onMoveNode($event)"
    (dragstart)="handleDragStart()"
    >
    <ng-template #treeNodeTemplate let-node let-index="index">
        <context-menu #nodeMenu [disabled]="readonly || isMMSAuthor ||
        selectedFeatureScope === 'Client'">
        <!-- Refresh -->
        @if (!isMMSAuthor && !readonly) {
          <ng-template contextMenuItem (execute)="reloadItemsOverload()">
            <span [attr.data-testid]="'refresh_items'">Refresh</span>
            <mat-icon>refresh</mat-icon>
          </ng-template>
        }
        <!-- Old Enable/disable -->
        @if (!(newDisableToggle$ | async) && selectedFeatureScope === 'Global' && !node?.data?.data?.commonItem && !isMMSAuthor) {
          <ng-template contextMenuItem (execute)="toggleDisabled(node)"
            >
            <span
            [attr.data-testid]="'enable_disable'">{{ node?.data?.data?.disabled ? 'Enable' : 'Disable' }}</span>
            <mat-icon>{{ node?.data?.data?.disabled ? 'visibility' : 'visibility_off' }}</mat-icon>
          </ng-template>
        }
        <!-- New Enable/disable -->
        @if ((newDisableToggle$ | async) && selectedFeatureScope === 'Global' && !node?.data?.data?.commonItem && !isMMSAuthor) {
          <ng-template contextMenuItem (execute)="toggleDisabled(node)"
            >
            <!--                disabledCode: 111 means Disabled by EMM user-->
            <span [attr.data-testid]="'enable_disable'">
              {{
              !node?.data?.data?.disabled || node?.data?.data?.disabledCode !== 111 ?
              'Disable' : 'Enable'
              }}
            </span>
            <mat-icon>{{
              !node?.data?.data?.disabled || node?.data?.data?.disabledCode !== 111 ?
              'visibility_off' : 'visibility'
              }}
            </mat-icon>
          </ng-template>
        }
        <!-- Add -->
        @if (allowStructureChanges && selectedFeatureScope === 'Global' && location === 'CHAIN'
          && !node?.data?.data?.commonItem && !isMMSAuthor) {
          <ng-template
            contextMenuItem (execute)="add(node)">
            <span [attr.data-testid]="'add_item'">Add Item</span>
            <mat-icon>add</mat-icon>
          </ng-template>
        }
        <!-- Copy -->
        @if (allowStructureChanges && selectedFeatureScope === 'Global' && location === 'CHAIN'
          && !node?.data?.data?.commonItem && !isMMSAuthor) {
          <ng-template
            contextMenuItem
            (execute)="copy(node)"
            >
            <span [attr.data-testid]="'copy_item_button'"
            matTooltip="This will overwrite any item or tagpath you have previously copied">Copy Item</span>
            <mat-icon>file_copy</mat-icon>
          </ng-template>
        }
        <!-- Copy Tagpath -->
        @if (allowStructureChanges && !isMMSAuthor) {
          <ng-template
            contextMenuItem
            (execute)="copyTagpath(node)"
            >
            <span [attr.data-testid]="'copy_item_tagpath_button'"
              matTooltip="This will overwrite any item or tagpath you have previously copied"
            >Copy Tagpath</span>
            <mat-icon>file_copy</mat-icon>
          </ng-template>
        }
        <!-- Delete -->
        @if (allowStructureChanges && selectedFeatureScope === 'Global' && location === 'CHAIN' &&
          !isSubmenu(node) && !node?.data?.data?.commonItem && !isMMSAuthor) {
          <ng-template
            contextMenuItem (execute)="deleteNode(node)">
            <span [attr.data-testid]="'delete_item'">Delete</span>
            <mat-icon>delete</mat-icon>
          </ng-template>
        }
        <!-- Delete cascade -->
        @if (allowStructureChanges && selectedFeatureScope === 'Global' && location === 'CHAIN'
          && !node?.data?.data?.commonItem && !isMMSAuthor) {
          <ng-template
            contextMenuItem
            [visible]="!isSubmenu(node)"
            (execute)="deleteCascade(node)"
            >
            <span [attr.data-testid]="'delete_cascade'">Delete Cascade</span>
            &nbsp;
            <mat-icon>delete_sweep</mat-icon>
          </ng-template>
        }
        <!-- Paste -->
        @if (allowStructureChanges && selectedFeatureScope === 'Global' && location === 'CHAIN'
          && !node?.data?.data?.commonItem && !isMMSAuthor) {
          <ng-template
            contextMenuItem
            [disabled]="!isCopied"
            (execute)="paste(node)"
            >
            <span [attr.data-testid]="'paste_item_button'">Paste Item</span>
            <mat-icon>content_paste</mat-icon>
          </ng-template>
        }
        <!-- Paste cascade -->
        <ng-template
          contextMenuItem
          [disabled]="!isCopied"
                [visible]="!isSubmenu(node) && isAdmin && allowStructureChanges &&
                selectedFeatureScope === 'Global' && location === 'CHAIN' && !node?.data?.data?.commonItem && !isMMSAuthor"
          (execute)="pasteCascade(node)"
          >
          <span [attr.data-testid]="'paste_cascade'">Paste Cascade</span>
          <mat-icon>add_to_photos</mat-icon>
        </ng-template>
      </context-menu>
      <div
        [attr.data-testid]="node?.data?.name"
        [contextMenu]="nodeMenu"
        [contextMenuValue]="node.data"
        [matTooltip]="getDisabledTooltip(node)"
            [ngClass]="{ 'node-disabled': selectedConsumer?.tag !== 'MMS_LICENSEE' &&
            selectedConsumer?.tag !== 'MENU_ALIGNMENT' && node?.data?.data?.disabled,
            'node-disabled-MMS': node?.data?.data?.disabled &&
            (node?.data?.data?.disabledCode === 115 || node?.data?.data?.disabledCode === 116) &&
            (selectedConsumer?.tag === 'MMS_LICENSEE' || selectedConsumer?.tag === 'MENU_ALIGNMENT'),
            node: true }"
        >
        <span [ngClass]="{ 'strikethrough': node?.data?.isStruck }">
          {{ node?.data?.name }}
          @if (isSubmenu(node) && node.id.includes('_R2') || node.id.includes('_R3') || node.id.includes('_R4') ||
          node.id.includes('_R5')) {
            <mat-icon
              class="new-submenu-icon"
              matTooltip="This submenus uses some Common Items">
              fiber_new
            </mat-icon>
          }
          @if (isCommonItem(node)) {
            <mat-icon
              class="common-item-icon"
              matTooltip="Common Item">
              link
            </mat-icon>
          }
        </span>
        @if (showTags$ | async) {
          <span [ngStyle]="{ fontSize: '13px' }">
            - {{ node?.data?.data?.tag }}
          </span>
        }
        <!-- Display info icon when `fromBase` flag is false to indicate location has a snapshot override -->
        <!-- This may be deprecated once attribute table overrides are implemented -->
        @if (node?.data?.data?.typeName == 'Submenu') {
          <span>
            @if (node?.data?.data?.fromBase == false) {
              <mat-icon
                class="icon copy-icon"
                matTooltip="Submenu has location overrides"
              >copy_all</mat-icon>
            }
          </span>
        }
        @if (node?.data?.data?.selected) {
          <mat-icon
            class="icon green-check"
            matTooltip="Selected option"
            >check
          </mat-icon>
        }
      </div>
    </ng-template>
  </tree-root>
}
